import memoize from 'lodash/memoize'
import { createConfig, createStorage } from 'wagmi'
import { connectorsForWallets, getDefaultWallets } from '@rainbow-me/rainbowkit'
import { argentWallet, ledgerWallet, rabbyWallet } from '@rainbow-me/rainbowkit/wallets'
import { chains, publicClient } from './client'

export { chains, publicClient }

export const noopStorage = {
  getItem: (_key: any) => '',
  setItem: (_key: any, _value: any) => null,
  removeItem: (_key: any) => null,
}

const projectId = 'e542ff314e26ff34de2d4fba98db70bb'

const { wallets } = getDefaultWallets({
  appName: 'RainbowKit demo',
  projectId,
  chains,
})

const connectors = connectorsForWallets([
  ...wallets,
  {
    groupName: 'Other',
    wallets: [rabbyWallet({ chains }), argentWallet({ projectId, chains }), ledgerWallet({ projectId, chains })],
  },
])

export const wagmiConfig = createConfig({
  storage: createStorage({
    storage: typeof window !== 'undefined' ? window.localStorage : noopStorage,
    key: 'wagmi_v1.1',
  }),
  autoConnect: true,
  publicClient,
  connectors,
})

export const CHAIN_IDS = chains.map((c) => c.id)

export const isChainSupported = memoize((chainId: number) => (CHAIN_IDS as number[]).includes(chainId))
export const isChainTestnet = memoize((chainId: number) => {
  const found = chains.find((c) => c.id === chainId)
  return found ? 'testnet' in found : false
})
